export const formatUser = user => {
  let formatted = `${user.lastName}, ${user.firstName}`;
  formatted += user.middleName ? " " + user.middleName : "";
  formatted += user.credentials ? " " + user.credentials : "";
  return formatted;
};

export const formatProvider = (firstName, lastName, middleName) => {
  return `${lastName}, ${firstName} ${middleName ? middleName + " " : ""}`;
};
